import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Face from './Face';
import { PERIODS, answer, choose, load, period } from '../contributorsStore';
import { claim, release } from '../blocks';
import { t, ts } from '../util';
import formatCount from '../formatCount';
export function contributorsEnabled() {
  return app.forum.attribute('concourseShowContributors') !== false;
}
/**
 * Top Contributors, switchable between today, this week, this month and this
 * year. Ranked by likes received, or by comments on a forum without
 * flarum/likes (TopContributors.php).
 */
export default class TopContributors extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    claim('contributors', this.attrs.host);
    load();
  }
  onremove() {
    release('contributors', this.attrs.host);
  }
  view() {
    const current = period();
    const data = answer(current);
    const id = 'ConcourseContributors-period-' + this.attrs.host;
    return m("section", {
      className: "ConcourseBlock ConcourseContributors",
      "aria-label": ts('contributors.title')
    }, m("header", {
      className: "ConcourseBlock-head"
    }, this.attrs.heading === false ? null : m("h2", {
      className: "ConcourseBlock-title"
    }, t('contributors.title')), m("label", {
      className: "visually-hidden",
      for: id
    }, t('contributors.period_label')), m("select", {
      id: id,
      className: "ConcourseContributors-period",
      value: current,
      onchange: e => choose(e.target.value)
    }, PERIODS.map(p => m("option", {
      value: p
    }, t('contributors.period.' + p))))), !data ? m(LoadingIndicator, {
      size: "small",
      display: "block"
    }) : data.users.length ? m("ol", {
      className: "ConcourseContributors-list"
    }, data.users.map((user, i) => m("li", {
      key: user.id,
      className: i === 0 ? 'ConcourseContributors-first' : ''
    }, m("span", {
      className: "ConcourseContributors-rank",
      "aria-hidden": "true"
    }, i + 1, "."), m(Face, {
      person: user,
      link: true
    }), m("span", {
      className: "ConcourseContributors-text"
    }, m(Link, {
      href: app.route('user', {
        username: user.slug
      }),
      className: "ConcourseContributors-name"
    }, user.displayName), m("span", {
      className: "ConcourseContributors-count"
    }, t('contributors.' + data.metric, {
      count: user.count,
      formatted: formatCount(user.count)
    })))))) : m("p", {
      className: "ConcourseBlock-empty"
    }, t('contributors.empty.' + current)));
  }
}
flarum.reg.add('ernestdefoe-concourse', 'forum/components/TopContributors', TopContributors);